<mat-button-toggle-group class="st-planning-views-main-cta-button-group">
    <mat-button-toggle
        class="st-planning-views-main-cta-button-new-view"
        (click)="createViewState()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        {{ languageSettings.PSTWebNewLabel }}
    </mat-button-toggle>
</mat-button-toggle-group>
